import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as CourseService from "../../../../services/CourseService";
import { useTranslation } from "react-i18next";
import CourseForm from "./courseForm.view";
import PATHS from "../../../../constants/paths";
import {
  BreadCrumb,
  ShowAlertDialog,
} from "@de-prado-dev/react-component-library";

const FormFormContainer = ({ uuid }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});

  const setInitialValues = useCallback(async (data) => {
    const dataFinal = {
      name: data.name,
      description: data.description,
      document: data.document,
    };
    setInitValues(dataFinal);
  }, []);

  const loadData = useCallback(async () => {
    if (uuid) {
      const result = await CourseService.getCourse(uuid);
      if (result) {
        await setInitialValues(result);
      }
    }
  }, [setInitialValues, uuid]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        let result = undefined;
        values.countries = Array.isArray(values.countries)
          ? values.countries
          : values.countries?.split(",").map((c) => c.trim());
        if (uuid) {
          result = await CourseService.updateCourse(values, uuid);
        } else {
          result = await CourseService.addCourse(values);
        }

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.course.messages.update.title");
            text = t("forms.course.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.course.messages.create.title");
            text = t("forms.course.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.course.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          navigate(PATHS.LIST_COURSE);
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handleOnback = () => {
    navigate(PATHS.LIST_COURSE);
  };

  return (
    <CourseForm
      edit={uuid ? true : false}
      initialValues={initValues}
      onSubmit={handleSubmit}
      onBack={handleOnback}
    />
  );
};

FormFormContainer.propTypes = {
  t: PropTypes.any,
};

export default FormFormContainer;
